import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Container,
  Button,
  ButtonGroup,
  Badge,
} from "reactstrap";
import SimpleHeader from "@/components/Headers/SimpleHeader";
import PageFormContainer from "../PageFormContainer";
import RequiredPagesContainer from "../Display/RequiredPagesContainer";
import type { RootState } from "@/services/store";

export type CreatePageViewProps = {
  formSimplePages: boolean;
  /** Required-pages progress badge: 0, 1, "done" (two), "..." (more), undefined (no list). */
  resultNavFooter: number | string | undefined;
  onFormType: (name: string) => void;
  CurrentSite?: RootState["sites"]["site"];
};

const CreatePageView = ({
  formSimplePages,
  resultNavFooter,
  onFormType,
  CurrentSite,
}: CreatePageViewProps) => {
  return (
    <>
      <SimpleHeader name="Create Pages" parentName="Pages" />
      <Container className="mt--6" fluid>
        <Card>
          <CardHeader className="text-center">
            {formSimplePages ? (
              <h3 className="mb-0 text-primary text-center">Pick Page Type</h3>
            ) : (
              <h3 className="mb-0 text-primary text-center">
                Create Navigation/Footer
              </h3>
            )}

            <ButtonGroup
              aria-label="Basic example"
              className="float-right"
              role="group"
            >
              <Button
                className={formSimplePages ? "active" : ""}
                color="secondary"
                type="button"
                onClick={() => onFormType("simple")}
              >
                Custom Pages
              </Button>

              <Button
                className={!formSimplePages ? "active" : ""}
                color="secondary"
                type="button"
                onClick={() => onFormType("required")}
                disabled={resultNavFooter === "done" || resultNavFooter === "..."}
              >
                Navigation/Footer
                <Badge
                  color={resultNavFooter === "done" ? "success" : "danger"}
                  className={
                    resultNavFooter === "done" || resultNavFooter === "..."
                      ? ""
                      : "badge-md badge-circle badge-floating border-white"
                  }
                >
                  {resultNavFooter}
                </Badge>
              </Button>
            </ButtonGroup>
          </CardHeader>

          <CardBody className="text-center">
            {formSimplePages ? (
              <PageFormContainer />
            ) : (
              <RequiredPagesContainer />
            )}
          </CardBody>
        </Card>
      </Container>
    </>
  );
};


export default React.memo(CreatePageView);
